export default {
  label: '成本控制',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '负责成本核算、费用分配等工作',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '核算生产成本、销售成本及其他费用，分析成本构成，提出优化建议',
          id: '0-2-1',
        },
        {
          label: '制定成本核算办法，参与库存盘点和资产清查',
          id: '0-2-2',
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '学历要求：大专及以上学历，财会相关专业优先',
          id: '0-3-1',
        },
        {
          label: '技能要求：熟练使用ERP系统或其他财务软件，具备良好的数据分析能力和沟通能力',
          id: '0-3-2',
        },
        {
          label: '职业素养：具有较强的责任心、保密意识和团队合作精神',
          id: '0-3-3',
        }
      ],
    }
  ],
};